module.exports = __webpack_public_path__ + "assets/img/sp-questionnaire1.84831466.png";